import StudentSubmissionView from '../student/studentSubmissionView';
import InstructorSubmissionView from '../instructor/instructorSubmissionView';

type FormSubmissionPageProps = {
  refreshForms: () => Promise<void>;
};

const FormSubmissionPage: React.FC<FormSubmissionPageProps> = ({refreshForms}) => {
  const userRole = sessionStorage.getItem('role');

  if (!userRole) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {userRole === 'instructor' ? (
        <InstructorSubmissionView refreshForms={refreshForms} />
      ) : (
        <StudentSubmissionView refreshForms={refreshForms} />
      )}
    </div>
  );
};

export default FormSubmissionPage;
